class SummaryTime{
  constructor(name, id) {
    this.name = name
    this.id = id
    this.value = ''
    this.endTime = ''
  }
  get startTime(){
    return new Date().getFullYear() + '-' + this.id
  }
}

class SummaryNewModule{
  static NEWSUMMARYTIMEARRAY(){
    let arr = [
      new SummaryTime('一月', '01'),
      new SummaryTime('二月', '02'),
      new SummaryTime('三月', '03'),
      new SummaryTime('四月', '04'),
      new SummaryTime('五月', '05'),
      new SummaryTime('六月', '06'),
      new SummaryTime('七月', '07'),
      new SummaryTime('八月', '08'),
      new SummaryTime('九月', '09'),
      new SummaryTime('十月', '10'),
      new SummaryTime('十一月', '11'),
      new SummaryTime('十二月', '12'),
    ]
    return arr
  }
}

export{ SummaryTime, SummaryNewModule }
